import Phaser from "phaser";
import type { MapDefinition } from "@ninja/game-content";
import {
  bossEntranceMarkersFor,
  type BossEntranceMarker,
} from "./bossEntranceMarkerModel.js";

const MARKER_DEPTH = 10_000;

export class BossEntranceMarkerRenderer {
  private readonly markers: Phaser.GameObjects.Container[] = [];

  constructor(
    private readonly scene: Phaser.Scene,
    map: MapDefinition,
  ) {
    for (const marker of bossEntranceMarkersFor(map))
      this.markers.push(this.render(marker));
  }

  destroy(): void {
    for (const marker of this.markers) marker.destroy(true);
    this.markers.length = 0;
  }

  private render(marker: BossEntranceMarker): Phaser.GameObjects.Container {
    const ground = this.scene.add.graphics();
    ground.fillStyle(marker.color, 0.18);
    ground.fillCircle(0, 0, 24);
    ground.lineStyle(3, marker.color, 0.95);
    ground.strokeCircle(0, 0, 24);
    ground.fillStyle(marker.color, 0.95);
    ground.fillTriangle(0, -14, -7, -2, 7, -2);

    const plate = this.scene.add
      .rectangle(0, -72, 240, 48, 0x07121c, 0.95)
      .setStrokeStyle(2, marker.color, 0.95);
    const label = this.scene.add
      .text(0, -83, marker.detail, {
        color: `#${marker.color.toString(16).padStart(6, "0")}`,
        fontFamily: "monospace",
        fontSize: "10px",
        fontStyle: "bold",
        align: "center",
      })
      .setOrigin(0.5);
    const title = this.scene.add
      .text(0, -63, marker.label, {
        color: "#f4ead6",
        fontFamily: "Arial, sans-serif",
        fontSize: "14px",
        fontStyle: "bold",
        align: "center",
        fixedWidth: 224,
      })
      .setOrigin(0.5);

    return this.scene.add
      .container(marker.x, marker.y, [ground, plate, label, title])
      .setDepth(MARKER_DEPTH);
  }
}
